"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetModalSizeByName = void 0;
var _react = require("react");
var _useModalSize2 = require("./useModalSize");
var useSetModalSizeByName = function useSetModalSizeByName(name) {
  var cleanupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var _useModalSize = (0, _useModalSize2.useModalSize)(),
    setModalSizeByName = _useModalSize.setModalSizeByName;
  (0, _react.useEffect)(function () {
    name && setModalSizeByName(name);
    return function () {
      cleanupName && setModalSizeByName(cleanupName);
    };
  }, []);
};
exports.useSetModalSizeByName = useSetModalSizeByName;